var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.305 28.966c13.581 0 21.012-11.147 21.012-20.798 0-.314 0-.627-.014-.94a14.96 14.96 0 0 0 3.687-3.793c-1.325.585-2.751.97-4.249 1.155A7.368 7.368 0 0 0 34.996.542 14.782 14.782 0 0 1 30.3 2.309 7.406 7.406 0 0 0 24.915 0c-4.076 0-7.388 3.279-7.388 7.313a8 8 0 0 0 .187 1.668A21.043 21.043 0 0 1 2.491 1.34a7.254 7.254 0 0 0-.993 3.678c0 2.537 1.31 4.775 3.283 6.087a7.528 7.528 0 0 1-3.34-.913v.1c0 3.535 2.548 6.5 5.918 7.17a7.27 7.27 0 0 1-1.944.257c-.475 0-.936-.043-1.383-.128.937 2.908 3.673 5.017 6.899 5.074a14.908 14.908 0 0 1-9.174 3.137c-.59 0-1.18-.029-1.757-.1a21.164 21.164 0 0 0 11.305 3.264",
    fill: "#5BA3D5",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.14687204.svg";
export { ForwardRef as ReactComponent };